module.exports = __webpack_public_path__ + "static/img/tool2.8b45f2e4.png";